// file: src/KalkulatorNormirani.js

import React, { useState, useEffect } from 'react';
import './Kalkulator.css';
import { FiDollarSign } from 'react-icons/fi';

function KalkulatorNormirani() {
  const [unosTip, setUnosTip] = useState('bruto');   // bira se unos 'bruto' ili 'neto'
  const [bruto, setBruto] = useState('');
  const [neto, setNeto] = useState('');
  const [normirani, setNormirani] = useState('');     // postotak u UI (npr. "30" za 30%)
  const [errors, setErrors] = useState({ 
    bruto: '', 
    neto: '', 
    normirani: '' 
  });
  const [rezultati, setRezultati] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  // Funkcija za validaciju polja: nenegativni broj, a za normirane troškove dodatno 0 < x < 100
  const validateField = (name, value) => {
    let msg = '';
    if (value.trim() === '') {
      msg = 'Ovo polje je obavezno.';
    } else if (isNaN(Number(value))) {
      msg = 'Unesite validan broj.';
    } else {
      const num = Number(value);
      if (name === 'normirani') {
        if (num <= 0 || num >= 100) {
          msg = 'Postotak mora biti između 0 i 100 (isključivo).';
        }
      } else {
        if (num < 0) {
          msg = 'Unesite nenegativan broj.';
        }
      }
    }
    setErrors(prev => ({ ...prev, [name]: msg }));
  };

  // Kad se promijeni bruto + nema greške, zovemo backend
  useEffect(() => {
    if (unosTip === 'bruto') {
      if (
        bruto.trim() !== '' &&
        normirani.trim() !== '' &&
        errors.bruto === '' &&
        errors.normirani === ''
      ) {
        const payload = {
          bruto: parseFloat(bruto.replace(',', '.')),
          normirani: parseFloat(normirani.replace(',', '.'))
        };

        fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/ugovor-normirani/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(async (res) => {
            if (!res.ok) throw new Error('Greška pri izračunu.');
            const data = await res.json();
            setRezultati(data);
            setSubmitError(null);
          })
          .catch(err => {
            setRezultati(null);
            setSubmitError(err.message);
          });
      } else {
        setRezultati(null);
        setSubmitError(null);
      }
    }
  }, [bruto, normirani, errors.bruto, errors.normirani, unosTip]);

  // Kad se promijeni neto + nema greške, zovemo backend
  useEffect(() => {
    if (unosTip === 'neto') {
      if (
        neto.trim() !== '' &&
        normirani.trim() !== '' &&
        errors.neto === '' &&
        errors.normirani === ''
      ) {
        const payload = {
          neto: parseFloat(neto.replace(',', '.')),
          normirani: parseFloat(normirani.replace(',', '.'))
        };

        fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/ugovor-normirani/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(async (res) => {
            if (!res.ok) throw new Error('Greška pri izračunu.');
            const data = await res.json();
            setRezultati(data);
            setSubmitError(null);
          })
          .catch(err => {
            setRezultati(null);
            setSubmitError(err.message);
          });
      } else {
        setRezultati(null);
        setSubmitError(null);
      }
    }
  }, [neto, normirani, errors.neto, errors.normirani, unosTip]);

  const handleBrutoChange = (e) => {
    const v = e.target.value.replace(',', '.');
    setBruto(v);
    validateField('bruto', v);
  };

  const handleNetoChange = (e) => {
    const v = e.target.value.replace(',', '.');
    setNeto(v);
    validateField('neto', v);
  };

  const handleNormiraniChange = (e) => {
    const v = e.target.value.replace(',', '.');
    setNormirani(v);
    validateField('normirani', v);
  };

  const handleUnosTipChange = (e) => {
    setUnosTip(e.target.value);
    // resetiraj sva polja i greške
    setBruto('');
    setNeto('');
    setNormirani('');
    setErrors({ bruto: '', neto: '', normirani: '' });
    setRezultati(null);
    setSubmitError(null);
  };

  return (
    <>
      {/* Naslov aplikacije */}
      <header className="app-header">
        <h1>
          AUTORSKI UGOVOR <br />
          <br />
          (Obračun naknade po autorskom ugovoru)
        </h1>
      </header>

    <div className="container">
      {/* Dio za unos */}
      <div className="form-container card">
        <div className="form-header">
          <h2>
            Unos podataka
          </h2>
        </div>

        {/* Biranje vrste unosa (bruto/neto) */}
        <div className="field-group">
          <label htmlFor="unosTip" className="field-label">
            Izaberite vrstu unosa<span className="required">*</span>:
          </label>
          <select
            id="unosTip"
            className="field-select"
            value={unosTip}
            onChange={handleUnosTipChange}
          >
            <option value="bruto">Bruto</option>
            <option value="neto">Neto</option>
          </select>
        </div>

        {/* Polje za unos bruto */}
        {unosTip === 'bruto' && (
          <div className="field-group">
            <label htmlFor="bruto" className="field-label">
              Bruto<span className="required">*</span>:
            </label>
            <input
              type="text"
              id="bruto"
              className={`field-input ${errors.bruto ? 'shake' : ''}`}
              placeholder="npr. 2000,00"
              value={bruto}
              onChange={handleBrutoChange}
              onBlur={(e) => validateField('bruto', e.target.value.replace(',', '.'))}
            />
            {errors.bruto && <div className="error-text">{errors.bruto}</div>}
          </div>
        )}

        {/* Polje za unos neto */}
        {unosTip === 'neto' && (
          <div className="field-group">
            <label htmlFor="neto" className="field-label">
              Neto<span className="required">*</span>:
            </label>
            <input
              type="text"
              id="neto"
              className={`field-input ${errors.neto ? 'shake' : ''}`}
              placeholder="npr. 1400,00"
              value={neto}
              onChange={handleNetoChange}
              onBlur={(e) => validateField('neto', e.target.value.replace(',', '.'))}
            />
            {errors.neto && <div className="error-text">{errors.neto}</div>}
          </div>
        )}

        {/* Polje za unos normiranih troškova (postotak) */}
        <div className="field-group">
          <label htmlFor="normirani" className="field-label">
            Normirani troškovi (%)<span className="required">*</span>:
          </label>
          <input
            type="text"
            id="normirani"
            className={`field-input ${errors.normirani ? 'shake' : ''}`}
            placeholder="npr. 30 za 30%"
            value={normirani}
            onChange={handleNormiraniChange}
            onBlur={(e) => validateField('normirani', e.target.value.replace(',', '.'))}
          />
          {errors.normirani && <div className="error-text">{errors.normirani}</div>}
        </div>
      </div>

      {/* Dio za prikaz rezultata */}
      <div className="results-container card">
        {rezultati && (
          <>
            <h3 className="section-title">Rezultati</h3>
            <div className="results-section">
              <div className="result-row">
                <span>Bruto:</span>
                <span>{rezultati.bruto.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Doprinosi:</span>
                <span>{rezultati.doprinosi.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Normirani troškovi:</span>
                <span>{rezultati.normirani_troskovi.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Porez:</span>
                <span>{rezultati.porez.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Neto:</span>
                <span>{rezultati.neto.toFixed(2)}</span>
              </div>
            </div>
          </>
        )}
        {submitError && <div className="error-text">{submitError}</div>}
      </div>
    </div>
    </>
  );
}

export default KalkulatorNormirani;
